/**
 * Organizations resource - /api/organizations endpoints
 */
import { getLogger } from '@qwickapps/logging';
const log = getLogger('QwickForge.MiddlewareClient.OrganizationsResource');
export class OrganizationsResource {
    http;
    constructor(http) {
        this.http = http;
    }
    /**
     * Get current user's organization
     */
    async getCurrent() {
        log.debug('Getting current organization');
        const organization = await this.http.get('/api/organizations/current');
        log.debug('Organization retrieved', { id: organization.id, name: organization.name });
        return organization;
    }
}
//# sourceMappingURL=OrganizationsResource.js.map